export const GLOBAL_IMAGES = {
  dingo: require("./global/dingo.png"),
  dingoLogoText: require("./global/dingoLogoText.png"),
  onboarding_bg: require("./global/onboarding_bg.webp"),
  onboarding_bg_low_b: require("./global/onboarding_bg_low_brightness.webp"),
  yearContainerImage: require("./global/yearContainerImage.png"),
  notebook: require("./global/notebook.png"),
  medal: require("./global/medal-front-color.png"),
  avatar: require("./global/Avatar.png"),
  back: require("./global/Back.png"),
  next: require("./global/Next.png"),
  clickToContinue: require("./global/ClickToContinue.png"),
  AiPopupBG: require("./global/AiPopup.webp"),
  LoginBackButton: require("./components/auth/LoginBackButton.webp"),
  exclamationMark: require("./global/exclamationMark.png"),
  child: require("./global/child_care.png"),
  aiBG: require("./components/ai/ai_background.webp"),
  trouble: require("./components/ai/trouble.webp"),
  boardImage: require("./global/board.png"),
  foxImage: require("./global/fox.webp"),
  contentCardImage: require("./global/contentCardImage.webp"),
  chatBubble: require("./global/yearDashboardChatBubble_local.png"),
  chatBubble1: require("./global/yearDashboardChatBubble1_local.png"),
  chatBubble2: require("./global/chatBubble2_local.png"),
  coin: require("./global/coin.png"),
  loading: require("./global/loading.json"),
  progressReportImage: require("./global/progressReportImage.webp"),
  knowledgeCard: require("./global/knowledge_card.webp"),
  demoerror: require("./components/demo/demo_pass.webp"),
  badge: require("./global/badge_parent_report.png"),
  lesson_lock: require("./global/lesson_lock.png"),

};
export const HEADER = {
  About: require("./header/AboutIcon.png"),
  AI: require("./header/AIIcon.png"),
  Sound: require("./header/SoundHeader.png"),
  NoSound: require("./global/exclamationMark.png"),
  ReportCard: require("./header/ReportCard.png"),
  muteSound: require("./header/mute-sound.png"),
};

export const COMPONENTS_NAV = {
  nav_main: require("./components/nav-home/nav_main.png"),
};

export const COMPONENTS_LessonCom = {
  lesson_card_bg: require("./components/lessonCom/lesson_card_bg.webp"),
  lesson_card__grey_bg: require("./components/lessonCom/lesson_card_grey_bg.webp"),
  back: require("./components/lessonCom/Back.webp"),
  rectangle: require("./components/lessonCom/Rectangle.png"),
  red_continue_button: require("./components/lessonCom/red_continue_button.png"),
  year_completion_popup: require("./components/lessonCom/year_completion_popup.png"),
};

export const COMPONENTS_LessonDashboard = {
  lesson_dashboard_bg: require("./components/lessonDashboard/lesson_dashboard_bg.webp"),
};

export const Sounds = {
  correct: require("./sounds/correct_answer.mp3"),
  incorrect: require("./sounds/wrong_answer.mp3"),
  backgroundMusic: require("./sounds/background_music.mp3"),
};

export const YearBg = [
  require("./components/lessonDashboard/lesson_dashboard_bg.webp"),
  require("./components/lessonDashboard/Year1.webp"),
  require("./components/lessonDashboard/Year2.webp"),
  require("./components/lessonDashboard/Year3.webp"),
  require("./components/lessonDashboard/Year4.webp"),
  require("./components/lessonDashboard/Year5.webp"),
  require("./components/lessonDashboard/Year6.webp"),
  require("./components/lessonDashboard/Year7.webp"),
  require("./components/lessonDashboard/Year8.webp"),
  require("./components/lessonDashboard/Year9.webp"),
];

export const Buttons = {
  onIncorrect: require("./buttons/btn-wrong.webp"),
  clickToContinue: require("./buttons/clicktocontinue.webp"),
  onCorrect: require("./buttons/green.webp"),
  cross: require("./buttons/cross_x_close.webp"),
  letsGo: require("./buttons/letsgo.webp"),
};

export const SIDEBAR = {
  audio: require("./sidebar/audio_sidebar.png"),
  video: require("./sidebar/video_sidear.png"),
  expend: require("./sidebar/min_max_sidebar.png"),
  board: require("./sidebar/whiteboard_sidebar.png"),
  colapse: require("./sidebar/colapse.png"),
};

export const knowledgeCards = {
  1: [
    require("./components/lessonDashboard/knowledgeCards/year0/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year0/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year0/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year0/fact4.webp"),
  ],
  2: [
    require("./components/lessonDashboard/knowledgeCards/year1/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year1/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year1/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year1/fact4.webp"),
  ],
  3: [
    require("./components/lessonDashboard/knowledgeCards/year2/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year2/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year2/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year2/fact4.webp"),
  ],
  4: [
    require("./components/lessonDashboard/knowledgeCards/year3/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year3/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year3/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year3/fact4.webp"),
  ],
  5: [
    require("./components/lessonDashboard/knowledgeCards/year4/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year4/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year4/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year4/fact4.webp"),
  ],
  6: [
    require("./components/lessonDashboard/knowledgeCards/year5/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year5/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year5/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year5/fact4.webp"),
  ],
  7: [
    require("./components/lessonDashboard/knowledgeCards/year6/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year6/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year6/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year6/fact4.webp"),
  ],
  8: [
    require("./components/lessonDashboard/knowledgeCards/year7/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year7/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year7/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year7/fact4.webp"),
  ],
  9: [
    require("./components/lessonDashboard/knowledgeCards/year8/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year8/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year8/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year8/fact4.webp"),
  ],
  10: [
    require("./components/lessonDashboard/knowledgeCards/year9/fact1.webp"),
    require("./components/lessonDashboard/knowledgeCards/year9/fact2.webp"),
    require("./components/lessonDashboard/knowledgeCards/year9/fact3.webp"),
    require("./components/lessonDashboard/knowledgeCards/year9/fact4.webp"),
  ],
};

export const DOG_ANIMATIONS = {
  dog1: require("./dogs/dog_icon_2.json"),
  dog2: require("./dogs/dog_icon_3.json"),
  dog3: require("./dogs/dog_icon_4.json"),
  dog4: require("./dogs/dog_icon_5.json"),
  dog5: require("./dogs/dog_icon_6.json"),
  dog6: require("./dogs/dog_icon_7.json"),
  dog7: require("./dogs/dog_icon_8.json"),
  dog8: require("./dogs/dog_icon_9.json"),
  dog9: require("./dogs/dog_icon_10.json"),
  dog10: require("./dogs/dog_icon_11.json"),
  dog11: require("./global/dogAnimation.json"),
};

export const ASSESSMENT = {
  bg: require("./components/demo/assessment_bg.webp"),
  poalWithBoard: require("./components/demo/assessment_poal_with_board.webp"),
  pole: require("./components/demo/assessment_pole.webp"),
  board: require("./components/demo/assessment_board.webp"),

  continue: require("./components/demo/demo_btn_continue.webp"),
  retry: require("./components/demo/demo_btn_retry.webp"),
  failPopup: require("./components/demo/demo_fail.webp"),
  passPopup: require("./components/demo/demo_pass.webp"),
};

export const CLASS_BOOKING = {
  bg: require("./global/class_booking_bg.webp"),
  heroImage: require("./global/home_page_side_image.png"),
};
